module.exports = {"152971100":"乌斯太镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152971.json
// module id = 499
// module chunks = 0